import React from "react";
import styled from "styled-components";

import InputLabel from "@material-ui/core/InputLabel";
import CircularProgress from "@material-ui/core/CircularProgress";

const Label = styled(InputLabel)`
  && {
    display: flex;
  }
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  margin-left: 20px;
  margin-top: 13px;

  &.MuiInputLabel-shrink {
    margin-top: -8px;
    margin-left: 0;
  }
`;

const Spinner = styled(CircularProgress).attrs({ size: 14, role: "timer" })`
  && {
    margin-right: 40px;
  }
`;

const ProgressInputLabel = ({ loading, children, ...props }) => (
  <Label {...props}>
    <span>{children}</span>
    {loading ? <Spinner aria-label={`Loading ${children}`} /> : null}
  </Label>
);

export default ProgressInputLabel;
